<template>
  <div class="popup">
    <div
      v-show="upper.showPopup"
      class="mask ljb-mask"/>
    <van-popup
      v-model="upper.showPopup"
      :overlay="false"
      position="bottom">
      <div class="popup-title">
        <p class="title ljb-border">{{ upper.title }}</p>
        <img
          class="close"
          src="https://cdn.51ljb.cn/ljb-close_black.png"
          @click="closePopup">
      </div>
      <slot/>
      <div class="ljb-base-padding">
        <normal-btn
          :btn-text="upper.btnText"
          @btnClick="btnClick"/>
      </div>

    </van-popup>
  </div>
</template>

<script>
import { Popup } from 'vant'
import Vue from 'vue'
import NormalBtn from '@/components/common/NormalBtn'
Vue.use(Popup)
export default {
  name: 'PopupUpglide',
  components: {NormalBtn},
  props: {
    upper: {
      type: Object,
      default: function () {
        return ''
      }
    }
  },
  methods: {
    closePopup () {
      this.$emit('closePopup')
    },
    selectPayWay: function (item) {
      this.payWay = item.type
      console.log(this.payWay)
    },
    btnClick: function () {
      this.$emit('btnClick')
    }
  }
}
</script>

<style lang="scss" scoped>
  .popup-title{
    position:relative;
  }
  .title{
    font-size: 18px;
    line-height: 52px;
    text-align: center;
    color: $title-color;

  }
  .close{
    width: 20px;
    height: 20px;
    position: absolute;
    top:15px;
    right:15px;

  }
  .payTpe{
    background: #fff;
    box-sizing: border-box;
    line-height: 16px;
    padding: $padding 0;
  }
  .title-right{
    color: $base-color;
  }
  .border-line{
    border-top:10px solid $background-color
  }

</style>



// WEBPACK FOOTER //
// src/components/popup/PopupUpglide.vue